@if (value(); as profile) {
  <div class="space-y-6">
    <lib-section
      [title]="TRANSLATION_PATH + 'sections.profileInfo' | translate"
      icon="pi pi-user"
      iconColor="teal"
    >
      <ng-container actions>
        <p-button
          [label]="TRANSLATION_PATH + 'actions.editProfile' | translate"
          data-testid="profile-edit-button"
          icon="pi pi-pencil"
          severity="secondary"
          [outlined]="true"
          (onClick)="editProfile.emit()"
        />
      </ng-container>
      <ng-container content>
        <div class="mb-8 flex flex-col gap-4 md:flex-row md:items-center">
          @if (profile.photoUrl) {
            <img
              class="h-20 w-20 rounded-full object-cover"
              [src]="profile.photoUrl"
              [alt]="profile.fullName || 'Profile photo'"
            />
          } @else {
            <div class="h-20 w-20 rounded-full bg-slate-200"></div>
          }

          <div>
            <p-button
              [label]="TRANSLATION_PATH + 'actions.changePhoto' | translate"
              data-testid="profile-change-photo-button"
              icon="pi pi-upload"
              severity="secondary"
              [outlined]="true"
              (onClick)="changePhoto.emit()"
            ></p-button>

            <p class="mt-2 mb-0 text-sm text-slate-500">
              {{ TRANSLATION_PATH + 'helpers.imageFormats' | translate }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 gap-5 md:grid-cols-2">
          <div class="space-y-2">
            <p class="mb-0 text-base font-medium text-slate-600">
              {{ TRANSLATION_PATH + 'fields.fullName' | translate }}
            </p>
            <div
              class="min-h-14 rounded-[12px] border border-slate-200 bg-white px-4 py-3 text-xl font-medium text-slate-900"
              data-testid="profile-full-name-value"
            >
              {{ profile.fullName | fallbackValue }}
            </div>
          </div>

          <div class="space-y-2">
            <p class="mb-0 text-base font-medium text-slate-600">
              {{ TRANSLATION_PATH + 'fields.email' | translate }}
            </p>
            <div
              class="flex min-h-14 items-center gap-3 rounded-[12px] border border-slate-200 bg-white px-4 py-3 text-xl font-medium text-slate-900"
              data-testid="profile-email-value"
            >
              <i class="pi pi-envelope text-slate-500"></i>
              <span class="min-w-0 break-all">{{ profile.email | fallbackValue }}</span>
            </div>
          </div>

          <div class="space-y-2">
            <p class="mb-0 text-base font-medium text-slate-600">
              {{ TRANSLATION_PATH + 'fields.phone' | translate }}
            </p>
            <div
              class="flex min-h-14 items-center gap-3 rounded-[12px] border border-slate-200 bg-white px-4 py-3 text-xl font-medium text-slate-900"
              data-testid="profile-phone-value"
            >
              <i class="pi pi-phone text-slate-500"></i>
              <span>{{ profile.phone | fallbackValue }}</span>
            </div>
          </div>

          <div class="space-y-2">
            <p class="mb-0 text-base font-medium text-slate-600">
              {{ TRANSLATION_PATH + 'fields.role' | translate }}
            </p>
            <div
              class="min-h-14 rounded-[12px] border border-slate-200 bg-slate-50 px-4 py-3 text-xl font-medium text-slate-700"
            >
              {{ profile.role | fallbackValue }}
            </div>
          </div>
        </div>
      </ng-container>
    </lib-section>

    <lib-section
      [title]="TRANSLATION_PATH + 'sections.accountSecurity' | translate"
      icon="pi pi-lock"
    >
      <ng-container content>
        <div
          class="flex flex-col gap-4 rounded-[16px] border border-slate-200 bg-slate-50 px-4 py-4 md:flex-row md:items-center md:justify-between"
        >
          <div class="flex items-center gap-4">
            <i class="pi pi-shield text-slate-500"></i>

            <div>
              <p class="mb-1 text-base font-medium text-slate-600">
                {{ TRANSLATION_PATH + 'fields.password' | translate }}
              </p>
              <p class="m-0 text-xl font-medium text-slate-900">***************</p>
            </div>
          </div>

          <p-button
            [label]="TRANSLATION_PATH + 'actions.changePassword' | translate"
            data-testid="profile-change-password-button"
            severity="secondary"
            [outlined]="true"
            (onClick)="changePassword.emit()"
          ></p-button>
        </div>
      </ng-container>
    </lib-section>

    <lib-section [title]="TRANSLATION_PATH + 'sections.preferences' | translate" icon="pi pi-globe">
      <ng-container content>
        <div class="space-y-2">
          <p class="mb-0 text-base font-medium text-slate-600">
            {{ TRANSLATION_PATH + 'fields.language' | translate }}
          </p>
          <div
            class="inline-flex min-h-12 items-center gap-3 rounded-[12px] border border-slate-200 bg-white px-4 py-3 text-xl font-medium text-slate-900"
          >
            <i class="pi pi-globe text-slate-500"></i>
            <span>{{ profile.language | fallbackValue }}</span>
          </div>
        </div>
      </ng-container>
    </lib-section>

    <lib-section
      [title]="TRANSLATION_PATH + 'sections.activePlan' | translate"
      icon="pi pi-briefcase"
    >
      <ng-container content>
        <div
          class="rounded-[16px] border border-teal-200 bg-teal-50 px-4 py-4 md:flex md:items-center md:justify-between"
        >
          <div>
            <p class="mb-1 text-base font-medium text-slate-600">
              {{ TRANSLATION_PATH + 'fields.activePlan' | translate }}
            </p>
            <p
              class="m-0 text-[1.75rem] font-medium leading-tight text-teal-700"
              data-testid="profile-active-plan-value"
            >
              {{ profile.activePlan | fallbackValue }}
            </p>
          </div>

          <p-button
            [label]="TRANSLATION_PATH + 'actions.changePlan' | translate"
            data-testid="profile-change-plan-button"
            severity="secondary"
            [outlined]="true"
            (onClick)="changePlan.emit()"
          ></p-button>
        </div>
      </ng-container>
    </lib-section>
  </div>
}
